import { ConsentLevel, useCookieConsent } from 'db-npm-e4sc-rd-ui';
import * as React from 'react';
import { runInlineScript } from '../../shared/utils/runInlineScript';

type FacebookPixelProps = {
  fields: any;
};

// Facebook Pixel IDs are numeric; reject anything else to prevent breaking out of the script string.
const FACEBOOK_PIXEL_ID_PATTERN = /^[0-9]{8,20}$/;

const FacebookPixel: React.FC<FacebookPixelProps> = ({ fields = {} }) => {
  const facebookPixelId = fields['Facebook Pixel ID']?.value;
  const isValidFacebookPixelId = FACEBOOK_PIXEL_ID_PATTERN.test(facebookPixelId);
  // useCookieConsent reads document.cookie which doesn't exist during SSR.
  // Start with false to match SSR output, update after mount to avoid #418 mismatch.
  const [enableFacebookPixel, setEnableFacebookPixel] = React.useState(false);
  const cookieConsent = useCookieConsent();
  React.useEffect(() => {
    setEnableFacebookPixel(cookieConsent.isAllowed(ConsentLevel.Marketing) && isValidFacebookPixelId);
  }, [isValidFacebookPixelId]);

  React.useEffect(() => {
    if (!enableFacebookPixel) {
      return;
    }

    runInlineScript(
      `!function(f,b,e,v,n,t,s){{if(f.fbq)return;n=f.fbq=function(){{n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)}};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}}(window,document,"script","//connect.facebook.net/en_US/fbevents.js");fbq("init","{facebookPixelId}");fbq("track","PageView");`.replace(
        '{facebookPixelId}',
        facebookPixelId
      )
    );
  }, [enableFacebookPixel, facebookPixelId]);

  if (!enableFacebookPixel) {
    return null;
  }

  return (
    <span
      dangerouslySetInnerHTML={{
        __html:
          `<noscript><img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id={facebookPixelId}&ev=PageView&noscript=1" /></noscript>`.replace(
            '{facebookPixelId}',
            facebookPixelId
          ),
      }}
    ></span>
  );
};

export default FacebookPixel;
